// import { SubDomains } from "./DomainControl";
// import LookupServiceCall from "../api/LookupServiceCall";
import CallApi from '../apiConnect/CallApi';
import { ReactSession } from 'react-client-session';
import { CallConfirmDialog, glbGetAppSettings, glbGetCurrentDomain, glbGetLocalStorage, glbSetLocalStorage, glbSetSessionStorage } from './GlobalFunctions';
export const GetTenantFromDomain = async (lsbannerloaded, lodngwinfpo) => {
    try {
        glbSetSessionStorage("clearsession", "");
        //glbSetLocalStorage("clearsession", "");
        let lsEnvDomainHost = window.location.host;
        let lsEnvDomain = window.location.host;
        if (lsEnvDomain.includes("localhost:44466") || lsEnvDomain.includes("182.20.10.101:44466") || lsEnvDomain.includes("182.20.10.212:44466") || lsEnvDomain.includes("182.20.10.47:44466")) {
            lsEnvDomain = glbGetCurrentDomain();
        }
        if (typeof lodngwinfpo === "object" && lodngwinfpo !== null && lodngwinfpo.dn !== undefined) {
            lsEnvDomain = lodngwinfpo.dn;
        }
        if ((window.origin.includes("182.20.10.212:44466") || window.origin.includes("182.20.10.47:44466")) && typeof lodngwinfpo === "object" && lodngwinfpo !== null && lodngwinfpo.gw !== undefined) {
            let loconfig = glbGetLocalStorage("config");
            loconfig.gatewayurl = lodngwinfpo.gw;
            glbSetLocalStorage("config", loconfig);
        }
        lsEnvDomainHost = lsEnvDomain;
        lsEnvDomain = lsEnvDomain.replace(/:/g, "!");
        let lsEnvHost = window.location.href;
        if (lsEnvHost.includes("newdesign")) {
            lsEnvHost = window.location.origin;
        }
        ReactSession.set("currenttpdomain", lsEnvDomain);
        ReactSession.set("currenthref", lsEnvHost);
        //window.alert(lsEnvDomain)
        let lbcdnbannerandlogo = false;
        let loServerBannerInfo = { imgslno: -1, imgtrndate: "", bannerimg: "" };
        let loresult = await CallApi({ method: "get", lookup: "Organization/GetOrganization", params: { "dn": lsEnvDomain }, toa: "g", "dn": lsEnvDomain });
        if (loresult.status === 200 || loresult.status === true) {
            loresult.data.envdomain = lsEnvDomainHost;
            glbSetLocalStorage("domaininfo", loresult.data);
            if (loServerBannerInfo.hasOwnProperty("imgslno")) {
                loServerBannerInfo.imgslno = loresult.data.imgslno;
            }
            if (loServerBannerInfo.hasOwnProperty("imgtrndate")) {
                loServerBannerInfo.imgtrndate = loresult.data.imgtrndate;
            }
            if (!(loServerBannerInfo.imgslno > 0)) {
                loServerBannerInfo.imgslno = -1;
            }
            glbSetLocalStorage("applang", "");
            glbSetLocalStorage("deflang", "en");
            if (loresult.data.hasOwnProperty("addinfo")) {
                let loaddinfo = {};
                try {
                    if (String(loresult.data.addinfo).includes("{") && String(loresult.data.addinfo).includes("}")) {
                        loaddinfo = JSON.parse(loresult.data.addinfo);
                    }
                    if (typeof loaddinfo === "object" && loaddinfo.wstitle !== "" && loaddinfo.wstitle !== undefined && loaddinfo.wstitle !== null) {
                        document.title = loaddinfo.wstitle;
                    }
                    if (typeof loaddinfo === "object" && loaddinfo.appsett !== "" && loaddinfo.appsett !== undefined && loaddinfo.appsett !== null) {
                        // loaddinfo.appsett[0].as.cbl = "y";
                        glbSetLocalStorage("appsett", loaddinfo.appsett);
                    }
                    if (typeof loaddinfo === "object" && loaddinfo.applang !== "" && loaddinfo.applang !== undefined && loaddinfo.applang !== null && typeof loaddinfo.applang === "string") {
                        glbSetLocalStorage("applang", loaddinfo.applang);
                    }
                    if (typeof loaddinfo === "object" && loaddinfo.deflang !== "" && loaddinfo.deflang !== undefined && loaddinfo.deflang !== null && typeof loaddinfo.deflang === "string") {
                        glbSetLocalStorage("deflang", loaddinfo.deflang);
                    }
                    if (typeof loaddinfo === "object" && loaddinfo.tlydesgnreqd !== "") {
                        glbSetLocalStorage("tlydesgnreqd", loaddinfo.tlydesgnreqd);
                    }
                    if (typeof loaddinfo === "object" && loaddinfo.loginsett !== "" && loaddinfo.loginsett !== undefined && loaddinfo.loginsett !== null) {
                        glbSetLocalStorage("loginsett", loaddinfo.loginsett);
                    }
                    if (typeof loaddinfo === "object" && loaddinfo.cdata !== "" && loaddinfo.cdata !== undefined && loaddinfo.cdata !== null) {
                        glbSetLocalStorage("cdata", loaddinfo.cdata);
                    }
                }
                catch (err) {
                    console.log("Error in Getting Additional Info when domain getting");
                }
                let lohomeoptions = glbGetAppSettings("as");
                if (lohomeoptions !== "") {
                    if (lohomeoptions.cbl === "y") {
                        lbcdnbannerandlogo = true;
                    }
                }
            }
            // loServerBannerInfo.banrimg = loresult.data.logo;
        }
        else {
            glbSetLocalStorage("domaininfo", { errmsg: loresult.errmsg });
            let lserrormsg = loresult.errmsg;
            if (loresult.error && loresult.error.response && loresult.error.response.data) {
                lserrormsg = loresult.error.response.data;
            }
            CallConfirmDialog("warning", lserrormsg);
            return loresult;
        }
        if (lbcdnbannerandlogo) {
            lsEnvDomain = lsEnvDomainHost;
            let lsbannerlogopath = "";
            let loconfig = glbGetLocalStorage("config");
            if (process.env.REACT_APP_ENABLE_CDN === "false" || loconfig.localcdn === true) {
                let lbzissterapp = glbGetLocalStorage("zissterapp");
                lsEnvDomain = lsEnvDomain.replaceAll(".", "_").toLowerCase();
                lsbannerlogopath = lbzissterapp + "/cdn" + "/client/" + lsEnvDomain;
            }
            else {
                let loconfig = glbGetLocalStorage("config");
                if (loconfig.hasOwnProperty("cdnpath") && loconfig.cdnpath !== undefined && loconfig.cdnpath !== null && loconfig.cdnpath !== "") {
                    if (lsEnvDomain.includes("localhost:44466") || lsEnvDomain.includes("182.20.10.101:44466") || lsEnvDomain.includes("182.20.10.212:44466") || lsEnvDomain.includes("182.20.10.47:44466")) {
                        lsEnvDomain = lsEnvDomain.replaceAll(":", "_").toLowerCase();
                    }
                    else {
                        lsEnvDomain = lsEnvDomain.replaceAll(".", "_").toLowerCase();
                        lsEnvDomain = lsEnvDomain.replaceAll(":", "_").toLowerCase();
                    }
                    lsbannerlogopath = loconfig.cdnpath + "/client/" + lsEnvDomain;
                }
            }
            await glbSetLocalStorage("logopath", lsbannerlogopath);
        }
        else {
            let lbdifferentbanner = true;
            let loLocStoreBannerInfo = glbGetLocalStorage("bannerinfo");
            if (loLocStoreBannerInfo !== "" && loLocStoreBannerInfo !== undefined && loLocStoreBannerInfo !== null) {
                if (loLocStoreBannerInfo.hasOwnProperty("imgslno") && loLocStoreBannerInfo.hasOwnProperty("imgtrndate")) {
                    if (loLocStoreBannerInfo.imgslno === loServerBannerInfo.imgslno && loLocStoreBannerInfo.imgtrndate === loServerBannerInfo.imgtrndate) {
                        lbdifferentbanner = false;
                    }
                }
            }
            // console.log(loLocStoreBannerInfo);
            if (lsbannerloaded === "nobannerload") {
                lbdifferentbanner = false;
            }
            try {
                if (lbdifferentbanner === true) {
                    // console.log("different");
                    if (loLocStoreBannerInfo === "") {
                        loLocStoreBannerInfo = { imgslno: "", imgtrndate: "", bannerimg: "" };
                    }
                    if (loServerBannerInfo.imgslno > 0 || loServerBannerInfo.imgslno === -1) {
                        let loResult = await CallApi({ method: "get", lookup: "Organization/GetBanner", params: { "pnslno": loServerBannerInfo.imgslno }, toa: "g" });
                        if (loResult.status === 200 || loResult.status === true) {
                            // console.log(loResult);
                            loLocStoreBannerInfo.bannerimg = loResult.data.bannerimg;
                            loLocStoreBannerInfo.imgslno = loServerBannerInfo.imgslno;
                            loLocStoreBannerInfo.imgtrndate = loServerBannerInfo.imgtrndate;
                            glbSetLocalStorage("bannerinfo", loLocStoreBannerInfo);
                        }
                        else {
                            glbSetLocalStorage("bannerinfo", loLocStoreBannerInfo);
                            CallConfirmDialog("warning", loResult.errmsg);
                        }
                    }
                    else {
                        glbSetLocalStorage("bannerinfo", loLocStoreBannerInfo);
                    }
                }
            }
            catch (error) {
                console.log(error)
                CallConfirmDialog("warning", "local storage limit exceeded, kindly clear local storage and proceed");
            }
        }
        return loresult;
    }
    catch (err) {
        console.log(err);
        CallConfirmDialog("warning", err.message);
    }
}

